import React from 'react'
import logo from '../logo.png'
import {Form, Segment, Button, Message} from 'semantic-ui-react'
import {createAPIClient} from '../../../services/api'

export default class SendEmail extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      emailSent: false,
      error: undefined,
      isLoading: false,
      validEmail: false
    }
  }

  onFieldChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
    if (e.target.name === 'email') {
      const email = e.target.value
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let flag = re.test(String(email).toLowerCase())
      this.setState({validEmail: flag})
    }
  }

  submit () {
    const api = createAPIClient()
    const form = {email: this.state.email}
    this.setState({isLoading: true})
    api.put('/auth/resetpassword/request', form)
      .then(results => {
        this.setState({validEmail: false, email: '', emailSent: true, error: undefined, isLoading: false})
      })
      .catch(error => {
        this.setState({error: 'Could not find given email address', isLoading: false})
      })
  }

  render () {
    let errorNode

    if (this.state.error) {
      errorNode = <Message negative>{this.state.error}</Message>
    }

    let successNode
    if (this.state.emailSent) {
      successNode = <Message info>
        <p>Help is on the way. We've sent you an email with instructions for changing your password.</p>
      </Message>
    }

    return (
      <div>
        <img style={{'display': 'block', 'maxWidth': '60%', 'margin': '2em auto'}} src={logo} alt='Factoripad'/>
        <Segment>
          <Form loading={this.state.isLoading} onSubmit={this.submit.bind(this)}>
            <h2>Reset password</h2>
            {successNode}
            {errorNode}
            <Form.Field>
              <label htmlFor='email'>Email</label>
              <input autoFocus onChange={this.onFieldChange.bind(this)} type='email' id='email' name='email'
                     value={this.state.email} />
            </Form.Field>
            <Button disabled={!this.state.validEmail} primary type='submit'>Reset password</Button>

          </Form>
        </Segment>
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./src/pages/resetpassword/sendemail/index.js